/**
 * Permission codes that are no longer assignable (removed from RBAC catalog).
 * Keeps role/employee forms and selectors aligned when API still returns legacy codes.
 */
const RETIRED_PERMISSION_CODES = new Set(['delete_orders']);

export function stripRetiredPermissionCodes(codes: string[]): string[] {
  return codes.filter((c) => !RETIRED_PERMISSION_CODES.has(c));
}

export function filterRetiredPermissionsFromList<T extends { code: string }>(
  items: T[]
): T[] {
  return items.filter((item) => !RETIRED_PERMISSION_CODES.has(item.code));
}
